module.exports = __webpack_public_path__ + "images/univedda0ebc8341e8fc4b237bb0e2c9b276c.png";